import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { terminalCreateAndUpdateCode, terminalCreateAndUpdateCodeResponse } from "./TerminalManagementData/TerminalCreateAndUpdateCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const TerminalCreateAndUpdateComponent = () => {
    const [selectedLanguageTerminalCreateAndUpdate, setSelectedLanguageTerminalCreateAndUpdate] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageTerminalCreateAndUpdate(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'terminalCreateAndUpdate' ? terminalCreateAndUpdateCode[selectedLanguageTerminalCreateAndUpdate].request : terminalCreateAndUpdateCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};


    return (
<section className="docs-section" id="terminal-update">
                <div className="row flexbox">
                    <div className="col-md-5">
                        <h2 className="section-heading">Terminal Create & Update</h2>
                        <p><span className="badge badge-secondary back-green">POST</span><span className="api"> /terminal/createUpdate</span></p>
                        <p>Creates a terminal update with the package content received from GetPackages(/terminal/getPackages/{'{customerId}'}/{'{model}'}) API</p>

                        <h4>Request Body</h4>

                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">customerId</span> &nbsp; &nbsp; <b>number</b></p>
                            <p className="description">Customer ID - Identifies the customer within the Access system. <br />
                                This id can be found in the URL of each customer that you have access to. <i>/OnBoarding/ModifyCustomer?id=%</i></p>
                        </div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">packageIds</span> &nbsp; &nbsp; <b>array of strings</b></p>
                            <p className="description">Array of package ids</p></div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">serialNumbers</span> &nbsp; &nbsp; <b>array of strings</b></p>
                            <p className="description">Array of serials numbers which required respective package updates.</p>
                        </div>
                        <br />

                        <div className="response-codes">
                            <h4>Response Codes</h4>
                            <div className="table-wrapper">
                                <h6 className="header">HTTP Status code summary</h6>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>200 Success</td>
                                            <td>Get terminalid request was successful.</td>
                                        </tr>
                                        <tr>
                                            <td>400 Bad Request</td>
                                            <td>Bad request format or validation failed for incorrect data formats.</td>
                                        </tr>
                                        <tr>
                                            <td>401 Unauthorized</td>
                                            <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header.</td>
                                        </tr>
                                        <tr>
                                            <td>404 Resources not found</td>
                                            <td>If request cannot find data for provided data.</td>
                                        </tr>
                                        <tr>
                                            <td>422 Unprocessable entity</td>
                                            <td>Indicates that the server understands the request but cannot process it due to semantic errors or invalid data in the request payload.</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(terminalCreateAndUpdateCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langTerminalCreateAndUpdate" id={`${language}TerminalCreateAndUpdate`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageTerminalCreateAndUpdate === language} />
                                                <label htmlFor={`${language}TerminalCreateAndUpdate`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'terminalCreateAndUpdate' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("terminalCreateAndUpdate")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'terminalCreateAndUpdate' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageTerminalCreateAndUpdate]} style={dracula} showLineNumbers>
                                        {terminalCreateAndUpdateCode[selectedLanguageTerminalCreateAndUpdate].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'terminalCreateAndUpdateResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("terminalCreateAndUpdateResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'terminalCreateAndUpdateResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {terminalCreateAndUpdateCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>

        </div>
        </section>
    );
};

export default TerminalCreateAndUpdateComponent;